import React, { useEffect, useRef } from 'react';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectBoxedField.module.scss';

export default function SelectStreet(props: any) {
  const {selectedStreet, setSelectedStreet, onChangeStreet, readOnly = false, required = false } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;
  
  const maxNumberOfCharacters: number = 100;

  useEffect(() => {
    if (initialValue.current) {
      setSelectedStreet(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedStreet])

  const handleStreetChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setSelectedStreet(value);
    onChangeStreet();
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let value: string = event.target.value;
    setSelectedStreet(value.trim());
  }

  return (
    <form className={cx('root')} noValidate autoComplete="off">
      <div>
        <TextField
          disabled={readOnly}
          label="Street Address"
          defaultValue={undefined}
          inputProps={{
            readOnly: readOnly
          }}
          variant="outlined"
          value={selectedStreet}
          onInput={handleStreetChange}
          onBlur={handleBlur}
          placeholder="Enter street address."
          required={required}
        />
      </div>
    </form>
  );
}